import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import StatusBar from "components/StatusBar";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import { RowContainer } from "./styles";
import { useMutation } from "@apollo/client";
import {
  UPDATE_BOOKING_BY_BOOKING_ID,
  INVALIDATE_KEY,
  UNLOCK_DOOR,
} from "graphql/service";
import { debouncedErrorMessage } from "utils/messageUtil";
import { message } from "antd";

const BookingInformation = ({ groupId, booking, refetch }) => {
  
  const navigate = useNavigate();

  const [checkOutOpen, setCheckOutOpen] = useState(false);
  const [confirmIsOpen, setConfirmIsOpen] = useState(false);
  const [cancelRoomParams, setCancelRoomParams] = useState({});

  const [unlockDoor, { loading: unlockDoorLoading }] = useMutation(
    UNLOCK_DOOR,
    {
      onCompleted: (data) => {
        if (data) {
          message.success("Door unlocked successfully!");
        }
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message;
          if (error.message.includes("Validation")) {
            content = JSON.stringify(
              error.graphQLErrors[0]?.extensions?.exception
            );
          }
          debouncedErrorMessage(content);
        }
      },
    }
  );

  const [invalidateKey, { loading: invalidateKeyLoading }] = useMutation(
    INVALIDATE_KEY,
    {
      onCompleted: (data) => {
        if (data) {
          message.success("Key invalidated successfully!");
        }
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message;
          if (error.message.includes("Validation")) {
            content = JSON.stringify(
              error.graphQLErrors[0]?.extensions?.exception
            );
          }
          debouncedErrorMessage(content);
        }
      },
    }
  );

  const handleAddVoucher = (e) => {
    //TODO:
  };

  const handleRedeemVoucher = () => {
    //TODO:
  };

  const handleBillToRoom = () => {
    //TODO:
  };

  const [updateBookingByBookingId, { loading }] = useMutation(
    UPDATE_BOOKING_BY_BOOKING_ID,
    {
      onCompleted: (updateBookingData) => {
        refetch();
        message.success("Booking updated successfully");
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message;
          if (error.message.includes("Validation")) {
            content = JSON.stringify(
              error.graphQLErrors[0]?.extensions?.exception
            );
          }
          debouncedErrorMessage(content);
        }
      },
    }
  );

  const handleSaveChanges = () => {
    if (loading) return;
    //TODO: 
  };

  return (
    <Card>
      <CardHeader>
        <div className="type">
          <div>
            <span>ROOM {booking.roomBookings[0]?.room?.roomNumber} </span>
            <span className="grey">
              {booking.roomBookings[0]?.room?.roomType?.name}
            </span>
          </div>
          <StatusBar status={booking.status} />
        </div>
      </CardHeader>
      <RowContainer>

      </RowContainer>
    </Card>
  );
};

export default BookingInformation;
